import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { toast } from "sonner";
import { eur } from "./docUtils";

export default function CreditNoteModal({ invoice, onClose, onSaved }) {
  const [mode, setMode] = useState("total");
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    const payload = { total: mode === "total", reason };
    if (mode === "partiel") {
      const amt = parseFloat(String(amount).replace(",", ".")) || 0;
      if (amt <= 0 || amt > invoice.total_ttc) { toast.error("Montant d'avoir invalide"); return; }
      payload.amount = amt;
    }
    setLoading(true);
    try {
      const r = await api.post(`/accounting/invoices/${invoice.id}/credit-notes`, payload);
      toast.success(`Avoir ${r.data.number} créé`);
      onSaved();
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={!!invoice} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm" data-testid="credit-note-modal" aria-describedby={undefined}>
        <DialogTitle className="font-heading font-bold text-lg">Créer un avoir</DialogTitle>
        {invoice && (
          <div className="space-y-3 mt-2">
            <p className="text-sm text-neutral-500">
              Avoir relatif à la facture <strong className="text-neutral-900">{invoice.number}</strong> ({eur(invoice.total_ttc)})
            </p>
            <div className="flex gap-2">
              {[["total", "Avoir total"], ["partiel", "Avoir partiel"]].map(([v, l]) => (
                <button key={v} onClick={() => setMode(v)} data-testid={`cn-mode-${v}`}
                  className={`flex-1 px-3 py-2 rounded-lg text-sm border transition-colors ${
                    mode === v ? "bg-neutral-900 text-white border-neutral-900 font-medium" : "bg-white text-neutral-500 border-neutral-200"}`}>
                  {l}
                </button>
              ))}
            </div>
            {mode === "partiel" && (
              <div>
                <Label className="text-xs">Montant de l'avoir TTC (€)</Label>
                <Input type="number" min="0" step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)}
                  className="mt-1" data-testid="cn-amount" autoFocus />
              </div>
            )}
            <div>
              <Label className="text-xs">Motif (affiché sur l'avoir)</Label>
              <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Ex : annulation de la prestation"
                className="mt-1" data-testid="cn-reason" />
            </div>
            <Button onClick={submit} disabled={loading} className="w-full bg-neutral-900 hover:bg-neutral-800 text-white" data-testid="cn-submit">
              {loading ? "Création…" : "Créer l'avoir"}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
